import { useMemo } from 'react';

import type { Hco, Hcp } from '@/core/graphql/generated/types';

import { useGetDcrSetupQuery } from '../_graphql/query/GetDCRSetup.hook';
import { DCR_CUSTOM_HCP_FIELDS } from '../_utils/mapHcpToFormDefaultsIn';
import { DCR_CUSTOM_HCO_FIELDS } from '../_utils/networkApiMappers/mapHcoToNetworkApiFieldNames';

type Props = {
	isModalOpen: boolean;
	countryId: Hcp['countryId'] | Hco['countryId'];
};

export const useDcrSetup = ({ isModalOpen, countryId: cId }: Props) => {
	const { data, loading } = useGetDcrSetupQuery({
		skip: !isModalOpen || !cId,
		variables: {
			countryId: cId ?? ''
		}
	});

	const customFieldMapping = useMemo(
		() => ({
			...DCR_CUSTOM_HCO_FIELDS,
			...DCR_CUSTOM_HCP_FIELDS
		}),
		[]
	);

	const unavailableFields = useMemo(() => {
		const rawResults =
			data?.dcrUnavailableFields.__typename === 'UnavailableFields'
				? data.dcrUnavailableFields.results
				: [];

		const fieldSet = new Set<string>();

		rawResults.forEach(apiFieldName => {
			fieldSet.add(apiFieldName);
			fieldSet.add(`${apiFieldName}Id`);

			const mappedFormName =
				customFieldMapping[apiFieldName as keyof typeof customFieldMapping];

			if (mappedFormName) {
				fieldSet.add(mappedFormName);
			}
		});

		return Array.from(fieldSet);
	}, [data, customFieldMapping]);

	return { unavailableFields, loading };
};
